<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="userprofil_block block relative w-full">
      <div class="body_inners block relative pl-4 pr-4">
        <div class="info-block block relative">
          <div class="top-block block relative">
            <h4
              class="
                title-block
                block
                text-lg
                font-bold
                m-0
                text-darkblack text-center
                mb-6
              "
            >
            
              {{ $t("pages.profile_document.my_document") }}
            </h4>
            <p class="block text-xs font-bold mb-2 text-darkblack text-left">
              {{ $t("pages.profile_document.upload_document") }}
            </p>
            <ul class="blcok relative mb-6">
              <li class="block mb-2">
                <p class="block text-darkgray1 text-xs font-mediumn">
                  1. edukacja opiekuńcza
                </p>
              </li>
              <li class="block mb-2">
                <p class="block text-darkgray1 text-xs font-mediumn">
                  2. rekomendacje
                </p>
              </li>
              <li class="block mb-2">
                <p class="block text-darkgray1 text-xs font-mediumn">3. Inni</p>
              </li>
            </ul>
          </div>
          <div class="info-block block relative">
            <div class="customt-tabs-block block relative mb-4">
              <div
                class="
                  flex
                  items-start
                  justify-start
                  text-left
                  w-full
                  border border-tabs
                  rounded
                  overflow-hidden
                "
              >
                <div
                  class="
                    flex
                    items-center
                    justify-center
                    w-2/4
                    bg-transparent
                    relative
                    border border-tabs border-r
                    p-1
                    h-10
                  "
                  :class="{
                    'bg-darkgreen': firstCheckbox,
                    'bg-white': !firstCheckbox,
                  }"
                >
                  <input
                    id="first_checkbox"
                    v-model="firstCheckbox"
                    name="first_checkbox"
                    type="checkbox"
                    class="absolute left-0 top-0 w-full h-full opacity-0"
                    @click="onHandleChangeCheckbox"
                  />
                  <label
                    for="first_checkbox"
                    class="
                      flex
                      items-center
                      justify-center
                      text-center text-xs text-sm
                      font-semibold
                      w-full
                      h-full
                    "
                    :class="{
                      'text-white': firstCheckbox,
                      'text-darkgray1': !firstCheckbox,
                    }"
                  >
                    {{ $t("pages.user_profile.confirm") }}
                  </label>
                </div>
                <div
                  class="
                    flex
                    items-center
                    justify-center
                    w-2/4
                    bg-transparent
                    relative
                    border border-tabs border-r
                    bg-white
                    p-1
                    h-10
                  "
                  :class="{ 'bg-darkgreen': secondCheckbox }"
                >
                  <input
                    id="second_checkbox"
                    v-model="secondCheckbox"
                    name="second_checkbox"
                    type="checkbox"
                    class="absolute left-0 top-0 w-full h-full opacity-0"
                    @click="onHandleChangeCheckbox"
                  />
                  <label
                    for="second_checkbox"
                    class="
                      flex
                      items-center
                      justify-center
                      text-center text-xs text-sm
                      font-semibold
                      w-full
                      h-full
                    "
                    :class="{
                      'text-white': secondCheckbox,
                      'text-darkgray1': !secondCheckbox,
                    }"
                  >
                    <span>{{ $t("pages.user_profile.processing") }}</span>
                  </label>
                </div>
              </div>
            </div>

            <div
              class="
                items-block
                block
                relative
                rounded
                border
                solid
                border-gr-color
                walter-shadow
                p-4
                mb-4
                overflow-hidden
                rounded-md
                current-shadow
              "
            >
              <div class="top-block flex items-start justify-start mb-5">
                <div class="w-3/4">
                  <h2
                    class="
                      flex
                      items-center
                      justify-start
                      text-sm
                      font-bold
                      mb-1
                      text-darkgray
                    "
                  >
                    dowód osobisty
                    <span class="pl-1.5">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.26902 1.66248C5.38894 1.64971 5.51683 1.68009 5.63295 1.76143L6.21629 2.17029C6.73944 2.5362 7.44087 2.53665 7.96368 2.17029L8.54636 1.76143C8.85602 1.54451 9.25203 1.68848 9.34975 2.05375L9.53334 2.7419C9.69826 3.3585 10.2353 3.80883 10.8712 3.8643L11.5802 3.92615C11.9568 3.95901 12.1678 4.32404 12.008 4.66638L11.7065 5.31156C11.4366 5.88997 11.5582 6.58039 12.0099 7.03162L12.5132 7.53487C12.7804 7.80194 12.7074 8.21698 12.3647 8.37667L11.7195 8.67745C11.1408 8.94679 10.7908 9.5535 10.8465 10.1892L10.909 10.8988C10.942 11.2754 10.6189 11.5463 10.254 11.4483L9.56655 11.2634C8.95002 11.098 8.29119 11.3375 7.92527 11.8604L7.51707 12.4437C7.30033 12.7535 6.87898 12.7542 6.66225 12.4444L6.25405 11.8604C5.88812 11.3375 5.22994 11.098 4.61342 11.2634L3.92527 11.4483C3.56044 11.5463 3.23793 11.2754 3.27097 10.8988L3.33347 10.1898C3.38944 9.55391 3.03875 8.94623 2.45977 8.6768L1.81459 8.37667C1.47183 8.21692 1.39862 7.8024 1.66615 7.53487L2.17006 7.03162C2.62178 6.58039 2.74334 5.88997 2.47345 5.31156L2.17201 4.66638C2.01221 4.32404 2.22251 3.95901 2.5991 3.92615L3.30873 3.8643C3.94465 3.80883 4.48105 3.3585 4.64597 2.7419L4.83022 2.05375C4.87907 1.87112 5.00263 1.74371 5.15248 1.68917C5.18995 1.67553 5.22905 1.66673 5.26902 1.66248ZM9.14662 5.1462C9.23724 5.05311 9.36052 4.99894 9.49037 4.99516C9.59102 4.99226 9.6902 5.01981 9.77493 5.07421C9.85966 5.12861 9.926 5.20732 9.96525 5.30005C10.0045 5.39277 10.0149 5.49518 9.99495 5.59389C9.97503 5.69259 9.92579 5.78298 9.85365 5.85323L6.52032 9.18656C6.42655 9.2803 6.29939 9.33295 6.16681 9.33295C6.03422 9.33295 5.90706 9.2803 5.81329 9.18656L4.14662 7.5199C4.09864 7.47382 4.06033 7.41864 4.03394 7.35758C4.00754 7.29651 3.9936 7.2308 3.99293 7.16428C3.99225 7.09776 4.00485 7.03177 4.03 6.97018C4.05514 6.9086 4.09232 6.85264 4.13936 6.8056C4.1864 6.75856 4.24235 6.72139 4.30394 6.69624C4.36553 6.6711 4.43151 6.65849 4.49803 6.65917C4.56455 6.65984 4.63027 6.67379 4.69133 6.70018C4.7524 6.72657 4.80758 6.76488 4.85365 6.81287L6.16681 8.12602L9.14662 5.1462Z"
                          fill="#4890D2"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.9728 0.942424C8.23915 0.755836 8.54126 0.670709 8.83933 0.672892C9.4951 0.677696 10.1303 1.10408 10.3152 1.79529L10.4995 2.48344C10.5566 2.69684 10.7377 2.84901 10.9578 2.8682L11.6675 2.93005C12.7042 3.02052 13.3537 4.14656 12.9136 5.08956L12.6128 5.73474C12.5193 5.935 12.56 6.16783 12.7163 6.32393L13.2202 6.82719C13.9563 7.56279 13.7306 8.84327 12.7872 9.28292L12.1421 9.5837C11.9417 9.67694 11.8232 9.88184 11.8426 10.1019L11.9051 10.8116C11.996 11.8483 11.0001 12.6838 9.99493 12.4138L9.30743 12.2295C9.09395 12.1723 8.87167 12.2528 8.74493 12.434L8.33673 13.0173C7.74013 13.8701 6.43984 13.8701 5.84324 13.0173L5.43503 12.434C5.30829 12.2528 5.08601 12.1723 4.87253 12.2295L4.18504 12.4138C3.17986 12.6838 2.18392 11.8483 2.27488 10.8116L2.33738 10.1019C2.35675 9.88184 2.23826 9.67694 2.0379 9.5837L1.39207 9.28292C0.448833 8.84333 0.223321 7.56299 0.959123 6.82719L1.46303 6.32393C1.61931 6.16783 1.66064 5.935 1.5672 5.73474L1.26576 5.08891C0.825569 4.14591 1.47576 3.02052 2.51251 2.93005L3.22149 2.8682C3.44158 2.84901 3.62275 2.69684 3.67983 2.48344L3.86407 1.79529C4.06579 1.04124 4.80326 0.602953 5.51902 0.682658C5.75761 0.709227 5.99408 0.793154 6.20717 0.942424L6.78985 1.35128C6.97203 1.4787 7.20828 1.47824 7.38946 1.35128L7.9728 0.942424ZM5.63295 1.76143C5.51683 1.68009 5.38894 1.64971 5.26902 1.66248C5.22905 1.66673 5.18995 1.67553 5.15248 1.68917C5.00263 1.74371 4.87907 1.87112 4.83022 2.05375L4.64597 2.7419C4.48105 3.3585 3.94465 3.80883 3.30873 3.8643L2.5991 3.92615C2.22251 3.95901 2.01221 4.32404 2.17201 4.66638L2.47345 5.31156C2.74334 5.88997 2.62178 6.58039 2.17006 7.03162L1.66615 7.53487C1.39862 7.8024 1.47183 8.21692 1.81459 8.37667L2.45977 8.6768C3.03875 8.94623 3.38944 9.55391 3.33347 10.1898L3.27097 10.8988C3.23793 11.2754 3.56044 11.5463 3.92527 11.4483L4.61342 11.2634C5.22994 11.098 5.88812 11.3375 6.25405 11.8604L6.66225 12.4444C6.87898 12.7542 7.30033 12.7535 7.51707 12.4437L7.92527 11.8604C8.29119 11.3375 8.95002 11.098 9.56655 11.2634L10.254 11.4483C10.6189 11.5463 10.942 11.2754 10.909 10.8988L10.8465 10.1892C10.7908 9.5535 11.1408 8.94679 11.7195 8.67745L12.3647 8.37667C12.7074 8.21698 12.7804 7.80194 12.5132 7.53487L12.0099 7.03162C11.5582 6.58039 11.4366 5.88997 11.7065 5.31156L12.008 4.66638C12.1678 4.32404 11.9568 3.95901 11.5802 3.92615L10.8712 3.8643C10.2353 3.80883 9.69826 3.3585 9.53334 2.7419L9.34975 2.05375C9.25203 1.68848 8.85602 1.54451 8.54636 1.76143L7.96368 2.17029C7.44087 2.53665 6.73944 2.5362 6.21629 2.17029L5.63295 1.76143Z"
                          fill="#4890D2"
                        />
                      </svg>
                    </span>
                  </h2>
                  <p
                    class="
                      flex
                      items-start
                      justify-start
                      text-xs
                      font-medium
                      m-0
                      text-darkgray1
                    "
                  >
                    Podziękuj mu Sir Amet
                  </p>
                </div>
                <div class="w-1/4">
                  <p class="flex items-start justify-end m-0">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.0003 0.504883C15.103 0.504883 14.2057 0.845069 13.5257 1.52539L2.45834 12.5918C2.24835 12.8018 2.09456 13.0629 2.01303 13.3496L0.529629 18.5439C0.493046 18.6725 0.491466 18.8084 0.525053 18.9378C0.558639 19.0671 0.626173 19.1852 0.720669 19.2797C0.815164 19.3742 0.93319 19.4417 1.06254 19.4753C1.19188 19.5089 1.32786 19.5073 1.45639 19.4707L6.6517 17.9873C6.65203 17.987 6.65235 17.9867 6.65268 17.9863C6.93744 17.9045 7.19794 17.7526 7.40854 17.542L18.4749 6.47461C19.8355 5.11405 19.8355 2.88595 18.4749 1.52539C17.7949 0.845069 16.8977 0.504883 16.0003 0.504883ZM16.0003 1.99609C16.5107 1.99609 17.0204 2.19276 17.4134 2.58594C17.4137 2.58594 17.4141 2.58594 17.4144 2.58594C18.2018 3.37337 18.2018 4.62663 17.4144 5.41406L16.4447 6.38379L13.6165 3.55566L14.5863 2.58594C14.9793 2.19276 15.4899 1.99609 16.0003 1.99609ZM12.556 4.61621L15.3841 7.44434L6.34701 16.4814C6.3177 16.5106 6.28057 16.5329 6.23861 16.5449L2.34213 17.6582L3.45541 13.7607C3.45541 13.7604 3.45541 13.7601 3.45541 13.7598C3.46688 13.7195 3.48788 13.6834 3.51889 13.6523L12.556 4.61621Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </p>
                </div>
              </div>
              <div class="flex items-start justify-start">
                <div class="w-3/4">
                  <label
                    class="
                      flex
                      items-center
                      justify-start
                      text-xs
                      font-medium
                      mb-1
                      text-darkgray
                    "
                  >
                    <b>data wejścia w życie: </b> 21.05.2026
                  </label>
                </div>
                <div class="w-1/4"></div>
              </div>
            </div>

            <div
              class="
                items-block
                block
                relative
                rounded
                border
                solid
                border-gr-color
                walter-shadow
                p-4
                mb-4
                overflow-hidden
                rounded-md
                current-shadow
              "
            >
              <div class="top-block flex items-start justify-start mb-5">
                <div class="w-3/4">
                  <h2
                    class="
                      flex
                      items-center
                      justify-start
                      text-sm
                      font-bold
                      mb-1
                      text-darkgray
                    "
                  >
                    dowód osobisty
                    <span class="pl-1.5">
                      <svg
                        width="14"
                        height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M5.26902 1.66248C5.38894 1.64971 5.51683 1.68009 5.63295 1.76143L6.21629 2.17029C6.73944 2.5362 7.44087 2.53665 7.96368 2.17029L8.54636 1.76143C8.85602 1.54451 9.25203 1.68848 9.34975 2.05375L9.53334 2.7419C9.69826 3.3585 10.2353 3.80883 10.8712 3.8643L11.5802 3.92615C11.9568 3.95901 12.1678 4.32404 12.008 4.66638L11.7065 5.31156C11.4366 5.88997 11.5582 6.58039 12.0099 7.03162L12.5132 7.53487C12.7804 7.80194 12.7074 8.21698 12.3647 8.37667L11.7195 8.67745C11.1408 8.94679 10.7908 9.5535 10.8465 10.1892L10.909 10.8988C10.942 11.2754 10.6189 11.5463 10.254 11.4483L9.56655 11.2634C8.95002 11.098 8.29119 11.3375 7.92527 11.8604L7.51707 12.4437C7.30033 12.7535 6.87898 12.7542 6.66225 12.4444L6.25405 11.8604C5.88812 11.3375 5.22994 11.098 4.61342 11.2634L3.92527 11.4483C3.56044 11.5463 3.23793 11.2754 3.27097 10.8988L3.33347 10.1898C3.38944 9.55391 3.03875 8.94623 2.45977 8.6768L1.81459 8.37667C1.47183 8.21692 1.39862 7.8024 1.66615 7.53487L2.17006 7.03162C2.62178 6.58039 2.74334 5.88997 2.47345 5.31156L2.17201 4.66638C2.01221 4.32404 2.22251 3.95901 2.5991 3.92615L3.30873 3.8643C3.94465 3.80883 4.48105 3.3585 4.64597 2.7419L4.83022 2.05375C4.87907 1.87112 5.00263 1.74371 5.15248 1.68917C5.18995 1.67553 5.22905 1.66673 5.26902 1.66248ZM9.14662 5.1462C9.23724 5.05311 9.36052 4.99894 9.49037 4.99516C9.59102 4.99226 9.6902 5.01981 9.77493 5.07421C9.85966 5.12861 9.926 5.20732 9.96525 5.30005C10.0045 5.39277 10.0149 5.49518 9.99495 5.59389C9.97503 5.69259 9.92579 5.78298 9.85365 5.85323L6.52032 9.18656C6.42655 9.2803 6.29939 9.33295 6.16681 9.33295C6.03422 9.33295 5.90706 9.2803 5.81329 9.18656L4.14662 7.5199C4.09864 7.47382 4.06033 7.41864 4.03394 7.35758C4.00754 7.29651 3.9936 7.2308 3.99293 7.16428C3.99225 7.09776 4.00485 7.03177 4.03 6.97018C4.05514 6.9086 4.09232 6.85264 4.13936 6.8056C4.1864 6.75856 4.24235 6.72139 4.30394 6.69624C4.36553 6.6711 4.43151 6.65849 4.49803 6.65917C4.56455 6.65984 4.63027 6.67379 4.69133 6.70018C4.7524 6.72657 4.80758 6.76488 4.85365 6.81287L6.16681 8.12602L9.14662 5.1462Z"
                          fill="#4890D2"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M7.9728 0.942424C8.23915 0.755836 8.54126 0.670709 8.83933 0.672892C9.4951 0.677696 10.1303 1.10408 10.3152 1.79529L10.4995 2.48344C10.5566 2.69684 10.7377 2.84901 10.9578 2.8682L11.6675 2.93005C12.7042 3.02052 13.3537 4.14656 12.9136 5.08956L12.6128 5.73474C12.5193 5.935 12.56 6.16783 12.7163 6.32393L13.2202 6.82719C13.9563 7.56279 13.7306 8.84327 12.7872 9.28292L12.1421 9.5837C11.9417 9.67694 11.8232 9.88184 11.8426 10.1019L11.9051 10.8116C11.996 11.8483 11.0001 12.6838 9.99493 12.4138L9.30743 12.2295C9.09395 12.1723 8.87167 12.2528 8.74493 12.434L8.33673 13.0173C7.74013 13.8701 6.43984 13.8701 5.84324 13.0173L5.43503 12.434C5.30829 12.2528 5.08601 12.1723 4.87253 12.2295L4.18504 12.4138C3.17986 12.6838 2.18392 11.8483 2.27488 10.8116L2.33738 10.1019C2.35675 9.88184 2.23826 9.67694 2.0379 9.5837L1.39207 9.28292C0.448833 8.84333 0.223321 7.56299 0.959123 6.82719L1.46303 6.32393C1.61931 6.16783 1.66064 5.935 1.5672 5.73474L1.26576 5.08891C0.825569 4.14591 1.47576 3.02052 2.51251 2.93005L3.22149 2.8682C3.44158 2.84901 3.62275 2.69684 3.67983 2.48344L3.86407 1.79529C4.06579 1.04124 4.80326 0.602953 5.51902 0.682658C5.75761 0.709227 5.99408 0.793154 6.20717 0.942424L6.78985 1.35128C6.97203 1.4787 7.20828 1.47824 7.38946 1.35128L7.9728 0.942424ZM5.63295 1.76143C5.51683 1.68009 5.38894 1.64971 5.26902 1.66248C5.22905 1.66673 5.18995 1.67553 5.15248 1.68917C5.00263 1.74371 4.87907 1.87112 4.83022 2.05375L4.64597 2.7419C4.48105 3.3585 3.94465 3.80883 3.30873 3.8643L2.5991 3.92615C2.22251 3.95901 2.01221 4.32404 2.17201 4.66638L2.47345 5.31156C2.74334 5.88997 2.62178 6.58039 2.17006 7.03162L1.66615 7.53487C1.39862 7.8024 1.47183 8.21692 1.81459 8.37667L2.45977 8.6768C3.03875 8.94623 3.38944 9.55391 3.33347 10.1898L3.27097 10.8988C3.23793 11.2754 3.56044 11.5463 3.92527 11.4483L4.61342 11.2634C5.22994 11.098 5.88812 11.3375 6.25405 11.8604L6.66225 12.4444C6.87898 12.7542 7.30033 12.7535 7.51707 12.4437L7.92527 11.8604C8.29119 11.3375 8.95002 11.098 9.56655 11.2634L10.254 11.4483C10.6189 11.5463 10.942 11.2754 10.909 10.8988L10.8465 10.1892C10.7908 9.5535 11.1408 8.94679 11.7195 8.67745L12.3647 8.37667C12.7074 8.21698 12.7804 7.80194 12.5132 7.53487L12.0099 7.03162C11.5582 6.58039 11.4366 5.88997 11.7065 5.31156L12.008 4.66638C12.1678 4.32404 11.9568 3.95901 11.5802 3.92615L10.8712 3.8643C10.2353 3.80883 9.69826 3.3585 9.53334 2.7419L9.34975 2.05375C9.25203 1.68848 8.85602 1.54451 8.54636 1.76143L7.96368 2.17029C7.44087 2.53665 6.73944 2.5362 6.21629 2.17029L5.63295 1.76143Z"
                          fill="#4890D2"
                        />
                      </svg>
                    </span>
                  </h2>
                  <p
                    class="
                      flex
                      items-start
                      justify-start
                      text-xs
                      font-medium
                      m-0
                      text-darkgray1
                    "
                  >
                    Podziękuj mu Sir Amet
                  </p>
                </div>
                <div class="w-1/4">
                  <p class="flex items-start justify-end m-0">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16.0003 0.504883C15.103 0.504883 14.2057 0.845069 13.5257 1.52539L2.45834 12.5918C2.24835 12.8018 2.09456 13.0629 2.01303 13.3496L0.529629 18.5439C0.493046 18.6725 0.491466 18.8084 0.525053 18.9378C0.558639 19.0671 0.626173 19.1852 0.720669 19.2797C0.815164 19.3742 0.93319 19.4417 1.06254 19.4753C1.19188 19.5089 1.32786 19.5073 1.45639 19.4707L6.6517 17.9873C6.65203 17.987 6.65235 17.9867 6.65268 17.9863C6.93744 17.9045 7.19794 17.7526 7.40854 17.542L18.4749 6.47461C19.8355 5.11405 19.8355 2.88595 18.4749 1.52539C17.7949 0.845069 16.8977 0.504883 16.0003 0.504883ZM16.0003 1.99609C16.5107 1.99609 17.0204 2.19276 17.4134 2.58594C17.4137 2.58594 17.4141 2.58594 17.4144 2.58594C18.2018 3.37337 18.2018 4.62663 17.4144 5.41406L16.4447 6.38379L13.6165 3.55566L14.5863 2.58594C14.9793 2.19276 15.4899 1.99609 16.0003 1.99609ZM12.556 4.61621L15.3841 7.44434L6.34701 16.4814C6.3177 16.5106 6.28057 16.5329 6.23861 16.5449L2.34213 17.6582L3.45541 13.7607C3.45541 13.7604 3.45541 13.7601 3.45541 13.7598C3.46688 13.7195 3.48788 13.6834 3.51889 13.6523L12.556 4.61621Z"
                        fill="#63B15B"
                      />
                    </svg>
                  </p>
                </div>
              </div>
              <div class="flex items-start justify-start">
                <div class="w-3/4">
                  <label
                    class="
                      flex
                      items-center
                      justify-start
                      text-xs
                      font-medium
                      mb-1
                      text-darkgray
                    "
                  >
                    <b>data wejścia w życie: </b> 21.05.2026
                  </label>
                </div>
                <div class="w-1/4"></div>
              </div>
            </div>
            <!-- Button block -->
            <div
              class="
                button-block
                block
                mb-0
                current_action
                fixed
                left-0
                bottom-0
                w-full
                px-4
                bg-white
              "
            >
              <div class="form-group block relative mb-0 pt-4 pb-4">
                <button
                  class="
                    w-full
                    flex
                    items-center
                    justify-center
                    btn_apply
                    rounded-lg
                    text-white
                    btn_action
                  "
                >
                  prześlij dokumenty
                </button>
              </div>
            </div>
            <!-- Button block -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "UserProfile2",
  data() {
    return {
      name: "",
      cell: "",
      surName: "",
      shouldModalOpen: false,
      firstCheckbox: true,
      secondCheckbox: false,
    };
  },
  watch: {
    firstCheckbox(newValue) {
      return newValue;
    },
    secondCheckbox(newValue) {
      return newValue;
    },
    name(val) {
      this.name = val.replace(/[0-9]/g, "");
    },
  },
  methods: {
    submit() {
      this.$router.push({
        name:
          this.name.toLowerCase() === "error"
            ? "checkLastnameFailed"
            : "confirmCell",
      });
    },
    toggleModal() {
      this.shouldModalOpen = !this.shouldModalOpen;
    },
    onHandleChangeCheckbox(event) {
      event.preventDefault();
      const { name, checked } = event.target;
      if (name === "first_checkbox" && checked) {
        this.firstCheckbox = true;
        this.secondCheckbox = false;
      } else if (name === "first_checkbox" && !checked) {
        this.firstCheckbox = false;
        this.secondCheckbox = true;
      } else if (name === "second_checkbox" && checked) {
        this.firstCheckbox = false;
        this.secondCheckbox = true;
      } else if (name === "second_checkbox" && !checked) {
        this.firstCheckbox = true;
        this.secondCheckbox = false;
      }
    },
    onlyNumber($event) {
      //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }

      if (this.cell.length >= 10) {
        $event.preventDefault();
      }
    },
  },
};
</script>

<style scoped>
body {
  padding-bottom: 0px !important;
}
</style>
